<template>
    <div>
        <div v-if="!showEditModal" class="edit-customer-v3-container">
            <div class="ppv2-p-6">
                <div class="ppv2-flex ppv2-flex-col lg:ppv2-flex-row ppv2-gap-6">
                    <!-- Left Column (65%) -->
                    <div class="ppv2-w-full lg:ppv2-w-[65%] ppv2-space-y-6">
                        <!-- Main Identity Card -->
                        <div class="ppv2-rounded-3xl ppv2-border ppv2-border-[#E2E8F0] ppv2-shadow-sm ppv2-relative">
                            <div :style="{ padding: normalizeSize(32, true) }">
                                <div class="ppv2-flex ppv2-items-center ppv2-gap-6 ppv2-mb-8 ppv2-flex-wrap">
                                    <h2
                                        class="ppv2-text-black poppinsBold ppv2-mb-0"
                                        :style="{ fontSize: normalizeFontSize(36) }"
                                    >
                                        {{ form.first_name }} {{ form.last_name }}
                                    </h2>
                                    <span
                                        class="ppv2-px-4 ppv2-py-2 ppv2-text-white ppv2-rounded-xl poppinsMedium"
                                        :style="{ fontSize: normalizeFontSize(14) }"
                                        :class="form.is_professional ? 'ppv2-bg-[#6366F1]' : 'bg-purple ppv2-bg-opacity-100'"
                                    >
                                        {{
                                            form.is_professional ? $t('customerInfo.professional') : $t('customerInfo.individual')
                                        }}
                                    </span>
                                    <BaseButton
                                        v-if="!form.deleted"
                                        variant="outline"
                                        class="ppv2-ml-auto ppv2-gap-3 !ppv2-rounded-full"
                                        :customHeight="35"
                                        :style="{ fontSize: normalizeFontSize(14) }"
                                        @click="editCustomer"
                                    >
                                        <Pencil :size="14" class="ppv2-text-black" />
                                        <span class="ppv2-text-black">{{ $t('common.edit') }}</span>
                                    </BaseButton>
                                </div>

                                <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-3 ppv2-gap-6">
                                    <div v-if="form.is_professional" class="ppv2-space-y-2">
                                        <p
                                            class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                            :style="{ fontSize: normalizeFontSize(14) }"
                                        >
                                            {{ $t('form_customer_v2.main_information.company_name.label') }}
                                        </p>
                                        <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                            {{ form.social_reason || '--' }}
                                        </p>
                                    </div>
                                    <div v-if="form.is_professional" class="ppv2-space-y-2">
                                        <p
                                            class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                            :style="{ fontSize: normalizeFontSize(14) }"
                                        >
                                            {{ $t('form_customer_v2.main_information.siret.label') }}
                                        </p>
                                        <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                            {{ form.siret || '--' }}
                                        </p>
                                    </div>
                                    <div v-if="form.is_professional" class="ppv2-space-y-2">
                                        <p
                                            class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                            :style="{ fontSize: normalizeFontSize(14) }"
                                        >
                                            {{ $t('form_customer_v2.main_information.vat.label') }}
                                        </p>
                                        <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                            {{ form.tva || '--' }}
                                        </p>
                                    </div>
                                    <div v-if="form.is_professional" class="ppv2-space-y-2">
                                        <p
                                            class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                            :style="{ fontSize: normalizeFontSize(14) }"
                                        >
                                            {{ $t('form_customer_v2.main_information.fix_phone.label') }}
                                        </p>
                                        <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                            {{ form.phone_fixed || '--' }}
                                        </p>
                                    </div>
                                    <div v-if="form.is_professional" class="ppv2-space-y-2">
                                        <p
                                            class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                            :style="{ fontSize: normalizeFontSize(14) }"
                                        >
                                            {{ $t('form_customer_v2.main_information.function.label') }}
                                        </p>
                                        <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                            {{ form.fonction || '--' }}
                                        </p>
                                    </div>
                                    <div class="ppv2-space-y-2">
                                        <p
                                            class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                            :style="{ fontSize: normalizeFontSize(14) }"
                                        >
                                            {{ $t('customerInfo.form.email.label') }}
                                        </p>
                                        <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                            {{ form.email || '--' }}
                                        </p>
                                    </div>
                                    <div class="ppv2-space-y-2">
                                        <p
                                            class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                            :style="{ fontSize: normalizeFontSize(14) }"
                                        >
                                            {{ $t('customerInfo.form.phone_number.label') }}
                                        </p>
                                        <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                            {{ form.phone_number || '--' }}
                                        </p>
                                    </div>
                                    <div class="ppv2-space-y-2">
                                        <p
                                            class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                            :style="{ fontSize: normalizeFontSize(14) }"
                                        >
                                            {{ $t('customerInfo.form.civility.label') }}
                                        </p>
                                        <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                            {{ form.gender || '--' }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Additional Info Card -->
                        <div class="ppv2-rounded-3xl ppv2-border ppv2-border-[#E2E8F0] ppv2-shadow-sm">
                            <div class="ppv2-border-b ppv2-border-[#E2E8F0]" :style="{ padding: normalizeSize(32, true) }">
                                <h3
                                    class="ppv2-mb-0 ppv2-text-black poppinsSemiBold"
                                    :style="{ fontSize: normalizeFontSize(20) }"
                                >
                                    {{ $t('customerInfo.titles.additional_information') }}
                                </h3>
                            </div>
                            <div
                                class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-2 lg:ppv2-grid-cols-4 ppv2-gap-6"
                                :style="{ padding: normalizeSize(32, true) }"
                            >
                                <div class="ppv2-space-y-2">
                                    <p
                                        class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                        :style="{ fontSize: normalizeFontSize(14) }"
                                    >
                                        Date de naissance
                                    </p>
                                    <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                        {{ formattedBirthday || '--' }}
                                    </p>
                                </div>
                                <div class="ppv2-space-y-2">
                                    <p
                                        class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                        :style="{ fontSize: normalizeFontSize(14) }"
                                    >
                                        {{ $t('customerInfo.form.address.label') }}
                                    </p>
                                    <p
                                        class="ppv2-text-black poppinsMedium ppv2-truncate ppv2-overflow-hidden"
                                        :style="{ fontSize: normalizeFontSize(16) }"
                                    >
                                        {{ formattedAddress || '--' }}
                                    </p>
                                </div>
                                <div class="ppv2-space-y-2">
                                    <p
                                        class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                        :style="{ fontSize: normalizeFontSize(14) }"
                                    >
                                        {{ $t('customerInfo.form.source_of_acquisition.label') }}
                                    </p>
                                    <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                        {{ originName || '--' }}
                                    </p>
                                </div>
                                <div class="ppv2-space-y-2">
                                    <p
                                        class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular"
                                        :style="{ fontSize: normalizeFontSize(14) }"
                                    >
                                        {{ $t('customerInfo.form.note.label') }}
                                    </p>
                                    <p class="ppv2-text-black poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                                        {{ form.internal_note || '--' }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="">
                            <h1 class="ppv2-mb-0 ppv2-text-black poppinsSemiBold" :style="{ fontSize: normalizeFontSize(20) }">
                                {{ $t('customerInfo.titles.orders_and_reservations') }}
                            </h1>
                            <OrderTable
                                :user-id="userId"
                                :token="token"
                                :exportView="false"
                                :searchView="false"
                                :is-deleted="form.deleted"
                                @total-updated="handleOrderTotal"
                            />
                        </div>

                        <div class="ppv2-mt-8">
                            <h1 class="ppv2-mb-0 ppv2-text-black poppinsSemiBold" :style="{ fontSize: normalizeFontSize(20) }">
                                {{ $t('customerInfo.titles.packages_and_subscriptions') }}
                            </h1>
                            <TreatmentCustomerTable
                                :exportView="false"
                                :user-id="userId"
                                :is-deleted="form.deleted"
                                :token="token"
                                @total-updated="handleTreatmentTotal"
                                :searchView="false"
                            />
                        </div>
                        <div class="ppv2-mt-8">
                            <h1 class="ppv2-mb-0 ppv2-text-black poppinsSemiBold" :style="{ fontSize: normalizeFontSize(20) }">
                                {{ $t('customerInfo.titles.vouchers') }}
                            </h1>
                            <VoucherTable
                                :columnsView="false"
                                :statusView="false"
                                :exportView="false"
                                :user-id="userId"
                                :is-deleted="form.deleted"
                                :token="token"
                                @total-updated="handleVoucherTotal"
                                :searchView="false"
                            />
                        </div>

                        <BackButton type="button" @click="navigateToIndex" />
                    </div>

                    <!-- Right Column (35%) -->
                    <div class="ppv2-w-full lg:ppv2-w-[35%] ppv2-space-y-6">
                        <!-- Metrics Card -->
                        <div
                            class="ppv2-rounded-3xl ppv2-border ppv2-border-[#E2E8F0] ppv2-shadow-sm ppv2-space-y-8"
                            :style="{ padding: normalizeSize(32, true) }"
                        >
                            <!-- Status Badges Decor -->
                            <div class="ppv2-flex ppv2-flex-col ppv2-gap-3">
                                <span
                                    class="ppv2-px-4 ppv2-py-2 ppv2-rounded-xl poppinsRegular ppv2-flex ppv2-items-center ppv2-justify-center ppv2-w-fit"
                                    :style="{ fontSize: normalizeFontSize(14) }"
                                    :class="
                                        form.active
                                            ? 'ppv2-bg-[#DCFCE7] ppv2-text-[#166534]'
                                            : 'ppv2-bg-[#FEE2E2] ppv2-text-[#991B1B]'
                                    "
                                >
                                    <Check v-if="form.active" class="ppv2-w-4 ppv2-h-4 ppv2-mr-2" />
                                    {{ form.active ? $t('common.enabled') : $t('common.disabled') }}
                                </span>
                                <span
                                    class="ppv2-px-4 ppv2-py-2 ppv2-rounded-xl ppv2-bg-white ppv2-border ppv2-border-[#E2E8F0] ppv2-text-[#000] poppinsRegular ppv2-flex ppv2-items-center ppv2-justify-center ppv2-w-fit"
                                    :style="{ fontSize: normalizeFontSize(14) }"
                                >
                                    <Check v-if="form.is_newsletter_subscribed" class="ppv2-w-4 ppv2-h-4 ppv2-mr-2" />
                                    <X v-else class="ppv2-w-4 ppv2-h-4 ppv2-mr-2" />
                                    {{ $t('customerInfo.form.registered_for_communications.label') }}
                                </span>
                            </div>

                            <!-- Metrics List -->
                            <MetricsList :metrics="metrics" />
                        </div>

                        <!-- Groups Card -->
                        <div class="ppv2-rounded-3xl ppv2-border ppv2-border-[#E2E8F0] ppv2-shadow-sm">
                            <div class="ppv2-border-b ppv2-border-[#E2E8F0]" :style="{ padding: normalizeSize(24, true) }">
                                <h3
                                    class="ppv2-mb-0 ppv2-text-black poppinsSemiBold"
                                    :style="{ fontSize: normalizeFontSize(20) }"
                                >
                                    {{ $t('customerInfo.titles.groups') }}
                                </h3>
                            </div>

                            <div class="ppv2-space-y-3" :style="{ padding: normalizeSize(32, true) }">
                                <p
                                    class="ppv2-text-black ppv2-text-opacity-90 poppinsRegular ppv2-mb-1"
                                    :style="{ fontSize: normalizeFontSize(14) }"
                                >
                                    {{ $t('customerInfo.form.groups.label') }}
                                </p>
                                <div class="ppv2-flex ppv2-flex-wrap ppv2-gap-2.5">
                                    <div
                                        v-for="(group, index) in groupOptions"
                                        :key="index"
                                        class="ppv2-px-5 ppv2-py-2 ppv2-bg-[#9333EA] ppv2-text-white ppv2-rounded-lg poppinsMedium ppv2-transition-all ppv2-duration-200 hover:ppv2-bg-[#7E22CE] hover:ppv2-shadow-md"
                                        :style="{ fontSize: normalizeFontSize(14) }"
                                    >
                                        {{ group.label }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Edit Modal -->
        <CustomerForm
            v-if="showEditModal"
            v-model="showEditModal"
            :customer-user="localCustomerUser"
            :customer-groups="customerGroups"
            :origins="origins"
            :genders="genders"
            :user-id="userId"
            :token="token"
            :wallet-balance="walletBalance"
            :spent-in="spentIn"
            :order-total="orderTotal"
            :treatment-total="treatmentTotal"
            :voucher-total="voucherTotal"
            :is-modal="true"
            @success="handleSuccess"
            @close="showEditModal = false"
        />
    </div>
</template>

<script>
import BaseButton from '../../Shared/BaseButton.vue'
import BackButton from '../../Shared/BackButton.vue'
import CustomerForm from './CustomerForm.vue'
import CustomerStatsNavigation from './CustomerStatsNavigation.vue'
import TreatmentCustomerTable from './Treatment/TreatmentCustomerTable.vue'
import OrderTable from './Order/OrderTable.vue'
import VoucherTable from './Voucher/VoucherTable.vue'
import MetricsList from './MetricsList.vue'
import normalizeSize from '../../../utils/normalizeSize'
import { Star, Wallet, CalendarCheck, CircleDollarSign, History, Gift, Calendar, Check, X, Pencil } from 'lucide-vue'
import normalizeFontSize from '../../../utils/normalizeFontSize'

export default {
    name: 'CustomerInfo',
    components: {
        BaseButton,
        BackButton,
        CustomerForm,
        CustomerStatsNavigation,
        Star,
        Wallet,
        CalendarCheck,
        CircleDollarSign,
        History,
        Gift,
        Calendar,
        Check,
        X,
        Pencil,
        VoucherTable,
        TreatmentCustomerTable,
        OrderTable,
        MetricsList,
    },
    props: {
        customerUser: { type: Object, default: () => null },
        customerGroups: { type: Array, default: () => [] },
        origins: { type: Array, default: () => [] },
        genders: { type: Array, default: () => [] },
        userId: { type: [Number, String], default: null },
        walletBalance: { type: [Number, String], default: null },
        spentIn: { type: [Number, String], default: null },
        token: { type: String, default: '' },
    },
    data() {
        return {
            showEditModal: false,
            activeTab: 'customers',
            stats: {
                customers: 0,
                groups: 0,
                newsletter_subscribers: 0,
                subscriptions: 0,
                treatments: 0,
                vouchers: 0,
            },
            voucherTotal: 0,
            treatmentTotal: 0,
            orderTotal: 0,
            form: {
                id: null,
                is_professional: false,
                last_name: '',
                first_name: '',
                email: '',
                phone_number: '',
                birthday: '',
                gender: null,
                address: '',
                active: true,
                is_newsletter_subscribed: true,
                internal_note: '',
                social_reason: '',
                siret: '',
                tva: '',
                fonction: '',
                phone_fixed: '',
                deleted: false,
            },
            localCustomerUser: null,
        }
    },
    computed: {
        formattedBirthday() {
            if (!this.form.birthday) return ''
            return new Date(this.form.birthday).toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: '2-digit',
            })
        },
        formattedAddress() {
            const parts = []
            if (this.form.street) parts.push(this.form.street)
            if (this.form.postal_code || this.form.city) {
                parts.push(`${this.form.postal_code || ''} ${this.form.city || ''}`.trim())
            }
            return parts.length > 0 ? parts.join('\n') : '--'
        },
        originName() {
            const customer = this.localCustomerUser?.customer || {}
            const originId = customer.origin_id
            const origin = this.origins.find((o) => o.id === originId)
            return origin ? origin.name : '--'
        },
        metrics() {
            const customer = this.localCustomerUser?.customer || {}
            return [
                { label: this.$t('customerInfo.metrics.loyalty_points'), value: customer.loyalty_points || 0, icon: Star },
                {
                    label: this.$t('customerInfo.metrics.wallet'),
                    value: this.walletBalance || '0,00' + this.$symbolCurrency,
                    icon: Wallet,
                },
                {
                    label: this.$t('customerInfo.metrics.reservations'),
                    value: this.orderTotal,
                    icon: CalendarCheck,
                },
                {
                    label: this.$t('customerInfo.metrics.total_spent'),
                    value:
                        new Intl.NumberFormat(this.$currencyLocale?.replace('_', '-') || 'fr-FR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }).format(this.spentIn ?? 0) + this.$symbolCurrency,
                    icon: CircleDollarSign,
                },
                { label: this.$t('customerInfo.metrics.packages_and_subscriptions'), value: this.treatmentTotal, icon: History },
                { label: this.$t('customerInfo.metrics.vouchers'), value: this.voucherTotal, icon: Gift },
                {
                    label: this.$t('customerInfo.metrics.date_created'),
                    value: this.formatDate(this.localCustomerUser?.created_at),
                    icon: Calendar,
                },
            ]
        },
        groupOptions() {
            const customer = this.localCustomerUser?.customer || {}
            // Handle both single group and multiple groups if they exist
            const customerGroupIds = customer.groups
                ? customer.groups.map((g) => g.id)
                : customer.customer_group
                  ? [customer.customer_group]
                  : []

            return this.customerGroups.filter((g) => customerGroupIds.includes(g.id)).map((g) => ({ label: g.name, value: g.id }))
        },
    },
    created() {
        if (this.customerUser) {
            this.localCustomerUser = { ...this.customerUser }
            this.initForm()
        }
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        handleVoucherTotal(total) {
            this.voucherTotal = total
        },
        handleTreatmentTotal(total) {
            this.treatmentTotal = total
        },
        handleOrderTotal(total) {
            this.orderTotal = total
        },
        initForm() {
            const customer = this.localCustomerUser.customer || {}
            const address =
                this.localCustomerUser.addresses && this.localCustomerUser.addresses.length > 0
                    ? this.localCustomerUser.addresses[0]
                    : {}
            const notes =
                this.localCustomerUser.notes && this.localCustomerUser.notes.length > 0 ? this.localCustomerUser.notes[0] : {}

            this.form = {
                id: this.localCustomerUser.id,
                is_professional: customer.customer_type == 1,
                last_name: this.localCustomerUser.last_name || '',
                first_name: this.localCustomerUser.first_name || '',
                email: this.localCustomerUser.email || '',
                phone_number: this.localCustomerUser.phone_number || '',
                birthday: this.localCustomerUser.birthday ? this.localCustomerUser.birthday.split(' ')[0] : '',
                gender: this.localCustomerUser.gender,
                street: address.street || '',
                postal_code: address.postal_code || '',
                city: address.city || '',
                active: this.localCustomerUser.status_id === 1,
                is_newsletter_subscribed: !!this.localCustomerUser.is_newsletter_subscribed,
                internal_note: notes.content || '',
                tva: customer.tva || '',
                siret: customer.siret || '',
                social_reason: customer.social_reason || '',
                fonction: customer.fonction || '',
                phone_fixed: customer.phone_fixed || '',
                deleted: this.localCustomerUser.deleted == 1,
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return '--'

            // Split date and time
            const [datePart] = dateStr.split(' ')
            const [day, month, year] = datePart.split('-')

            // Create date (month is 0-based in JS)
            const date = new Date(year, month - 1, day)

            return date.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            })
        },
        editCustomer() {
            this.showEditModal = true
        },
        handleSuccess(updatedData) {
            this.showEditModal = false
            if (updatedData) {
                // We need to merge the flat updatedData from the form into our deep localCustomerUser object
                // so that nested properties (like notes, addresses, customer attributes) are preserved for initForm()
                const newCustomerUser = { ...this.localCustomerUser }

                // Update basic user fields
                newCustomerUser.first_name = updatedData.first_name
                newCustomerUser.last_name = updatedData.last_name
                newCustomerUser.email = updatedData.email
                newCustomerUser.phone_number = updatedData.phone_number
                newCustomerUser.birthday = updatedData.birthday
                newCustomerUser.gender = updatedData.gender
                newCustomerUser.status_id = updatedData.active ? 1 : 2
                newCustomerUser.is_newsletter_subscribed = updatedData.is_newsletter_subscribed

                // Update customer attributes
                if (newCustomerUser.customer) {
                    newCustomerUser.customer.customer_type = updatedData.is_professional ? 1 : 0
                    newCustomerUser.customer.social_reason = updatedData.social_reason
                    newCustomerUser.customer.siret = updatedData.siret
                    newCustomerUser.customer.phone_fixed = updatedData.phone_fixed
                    newCustomerUser.customer.fonction = updatedData.fonction
                    newCustomerUser.customer.customer_group = updatedData.customer_group_id
                    newCustomerUser.customer.tva = updatedData.tva
                }

                // Update address (assuming index 0)
                if (newCustomerUser.addresses && newCustomerUser.addresses.length > 0) {
                    newCustomerUser.addresses[0].street = updatedData.street
                    newCustomerUser.addresses[0].postal_code = updatedData.postal_code
                    newCustomerUser.addresses[0].city = updatedData.city
                    newCustomerUser.addresses[0].country = updatedData.country
                }

                // Update internal note (assuming index 0)
                if (newCustomerUser.notes && newCustomerUser.notes.length > 0) {
                    newCustomerUser.notes[0].content = updatedData.internal_note
                } else if (updatedData.internal_note) {
                    // If there's no note but one was added, create a placeholder structure
                    newCustomerUser.notes = [{ content: updatedData.internal_note }]
                }

                this.localCustomerUser = newCustomerUser
                this.initForm()
            }
        },
        navigateToIndex() {
            window.location.href = '/back-office/v3/customer'
        },
    },
}
</script>

<style scoped lang="scss">
.edit-customer-v3-container {
    min-height: 100vh;
}

// Reset Vuetify app background if needed
:deep(.v-application--wrap) {
    min-height: auto;
}
</style>
